import memoizeOne from 'memoize-one';

import { getSuccessfulResultOrThrow } from '@atlassian/commerce-ccp-gateway-client/error-wrappers';
import type { EntitlementDetails } from '@atlassian/commerce-ccp-gateway-client';
import { entitlementsDetails_get_byEntitlementId_v1 } from '@atlassian/commerce-ccp-gateway-client';

import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';
import { cfetch } from '@confluence/network';
import CcpEntitlementIdQuery from './graphql/__generated__/CcpEntitlementIdQuery.graphql.ts';
import type { CcpEntitlementIdQuery as ccpEntitlementIdQueryRes } from './graphql/__types__/CcpEntitlementIdQuery.ts';

const memoizedEntitlementsDetails_get_byEntitlementId_v1 = memoizeOne(
	entitlementsDetails_get_byEntitlementId_v1,
	(
		[
			{
				pathParameters: { entitlementId: newEntitlementId },
			},
		],
		[
			{
				pathParameters: { entitlementId: lastEntitlementId },
			},
		],
	) => {
		return newEntitlementId === lastEntitlementId;
	},
);

export const getCurrentEntitlementDetails = async (): Promise<EntitlementDetails> => {
	// get current tenant's entitlement id
	const entitlementIdQuery = await queryInterop<ccpEntitlementIdQueryRes>({
		query: CcpEntitlementIdQuery,
	});
	const entitlementId =
		entitlementIdQuery?.data?.confluence_tenantContext?.licenseStates?.confluence
			?.ccpEntitlementId || '';

	if (!entitlementId) throw new Error('empty entitlementId');

	// get the entitlement details
	const entitlementDetails = getSuccessfulResultOrThrow(
		await memoizedEntitlementsDetails_get_byEntitlementId_v1({
			fetch: cfetch,
			pathParameters: {
				entitlementId,
			},
		}),
	);

	return entitlementDetails as EntitlementDetails;
};
